import React, { useEffect, useState } from "react";
import Summary from "../ControlPanel/Summary/Summary";
import Prices from "../ControlPanel/Common/DepositOrder/Prices.js";
import BuildingSummary from "../Header/BuildingSummary.js";
import { useSelector } from "react-redux";
import { clickOptionTime } from "../../action/index.js";
import {useDispatch} from 'react-redux';

const MobilePriceSummary = () => {
   const state = useSelector((state) => state.reducer);
   const [selectedTab, setSelectedTab] = useState(0);
   const [height, setHeight] = useState(window.innerHeight-50);
   const dispatch = useDispatch();

   let showPriceDiv = (state.const_var.loginSession == true || state.const_var.isKLinkEnable == true || state.const_var.is_Edit == true || state.const_var.loginSession.isPublicEdit == true || state.const_var.hide_price_calculation == false ) == true ? true : false
    
   if(state.const_var.isKLinkEnable == true && state.const_var.hide_price_calculation == true){
       showPriceDiv = false
   }
   if(state.const_var.loginSession == false && state.const_var.checkmoreCustomizeFlag == true){
       showPriceDiv = false
   }
   if(state.selectedTabstate == "statechange" || state.selectedTabstate == "buildstyle" || state.selectedTabstate == "loginstyletab"){
       showPriceDiv = false
   }
   if(state.const_var.post_data == undefined){
       showPriceDiv = false
   }
   
   const handleTabSelect = (tabIndex) => {
      setSelectedTab(tabIndex);
   };

   const hideSummaryModal = () => {   
      const removea = document.querySelector('body');   
      removea.classList.remove("active-total-price");
      dispatch(clickOptionTime(new Date()))
   }

   useEffect(() => {
      setSelectedTab(state.selectedPiceAndSummaryMobileView);
      if(showPriceDiv == false){
         setSelectedTab(1)
      }
   }, [showPriceDiv,state.selectedPiceAndSummaryMobileView])

   useEffect(() => {
      setHeight(window.innerHeight-50);
   }, [window.innerHeight])

   return (
         <div className="mobile-summary-wrapper">
            <div className="mobile-summary-header">
               <div className="summary-header">
                 {showPriceDiv == true &&
                  <h6
                     onClick={() =>  handleTabSelect(0) }
                     className={selectedTab === 0 ? "selected-tab" : ""}
                  >
                     Price Details
                  </h6>
                 }
                  <h6
                     onClick={() => handleTabSelect(1) }
                     className={selectedTab === 1 ? "selected-tab" : ""}
                  >
                     Product Summary
                  </h6>

               </div>
               <button
                  className="close"
                  onClick={hideSummaryModal}
               >
                  <span className="icon-close"></span>
               </button>
            </div>

            <div className="mobile-summary-body" style={{height: (height)+'px'}}>
               {
                  selectedTab === 0 ?
                  <div className={showPriceDiv == true ? "deposit-dropdown-wrapper" : "deposit-dropdown-wrapper d-none"}>
                     <Prices/>
                  </div>
                  :
                  <>
                     <BuildingSummary/>
                     <Summary/>
                  </>
               }
            </div>
         </div>
   );
};

export default MobilePriceSummary;